import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import UrlParse from 'url-parse';
import { mapGetters } from 'vuex';

var GlobalTitle = () => import(
/* webpackChunkName:"global-editorial" */
'~/components/atoms/Editorial/Global/GlobalTitle.vue');

var ProductItem = () => import(
/* webpackChunkName: "product" */
'~/components/library/Product/ProductItem.vue');

export default {
  name: 'ArticleProducts',
  components: {
    GlobalTitle,
    ProductItem
  },
  props: {
    payload: {
      type: Object,
      required: true
    },
    catalog: {
      type: Object,
      required: true
    }
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  })), {}, {
    currentPayload() {
      var _ref, _ref2, _ref3, _ref4;

      return {
        title: ((_ref4 = this.payload) != null ? (_ref4 = _ref4.primary) != null ? (_ref4 = _ref4.title) != null ? _ref4[0] : _ref4 : _ref4 : _ref4) || {},
        subtitle: ((_ref3 = this.payload) != null ? (_ref3 = _ref3.primary) != null ? (_ref3 = _ref3.subtitle) != null ? _ref3[0] : _ref3 : _ref3 : _ref3) || {},
        button: {
          text: ((_ref2 = this.payload) != null ? (_ref2 = _ref2.primary) != null ? _ref2.button_text : _ref2 : _ref2) || '',
          url: new UrlParse(((_ref = this.payload) != null ? (_ref = _ref.primary) != null ? (_ref = _ref.button_url) != null ? (_ref = _ref.link_type) != null ? _ref.url : _ref : _ref : _ref : _ref) || '').pathname
        }
      };
    }

  })
};